export default {
    state: {
        tokens: {},
        httpErrors: {
            network: {
                last: 0,
                count: 0,
                list: {}
            },
            timeout: {
                last: 0,
                count: 0,
                list: {}
            },
            '4xx': {
                last: 0,
                count: 0,
                list: {}
            },
            '5xx': {
                last: 0,
                count: 0,
                list: {}
            },
            canceled: {
                last: 0,
                count: 0,
                list: {}
            }
        },
        reload_required: false,
    },
    actions: {
        loginByToken({commit}, access_token) {
            return new Promise((resolve, reject) => {
                this.$api.auth.login({access_token})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateTokens', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    });
            })
        },
        refreshTokens({commit, getters}) {
            return new Promise((resolve, reject) => {
                if (!(getters.getRefreshToken > '')) {
                    return reject(false)
                }
                this.$api.auth.refreshTokens()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateTokens', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                            console.error(response);
                        }
                    })
                    .catch((error) => {
                        //commit('addRequestError', 'RefreshToken')
                        reject(error)
                        console.error(error);
                    });
            })
        },
        login({commit, dispatch}, props) {
            return new Promise((resolve, reject) => {
                this.$api.auth.login(props)
                    .then((response) => {
                        //console.log(response);
                        if (response.data && !response.data?.error) {
                            commit('updateTokens', response.data)
                        } else {
                            console.warn({...response.data});
                            reject(response.data)
                        }
                    })
                    .then(() => {
                        dispatch('fetchAppProps', {})
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
            })
        },
        // updateTokens({commit, dispatch}, tokens) {
        //     return new Promise((resolve, reject) => {
        //         if (!tokens) {
        //             return reject(false)
        //         }
        //         commit('updateTokens', tokens)
        //         return dispatch('fetchAppUser', {})
        //     })
        // },

        logout({commit}) {
            //this.$cookies.set('authtoken', '')
            this.$api.auth.logout({})
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    commit('updateTokens', {})
                });
        },

        calcTokensExpire({dispatch, commit}) {
            dispatch('setLastCall', {name: 'calcTokensExpire', time: Date.now() / 1000})

            Promise.resolve()
                .then(() => {
                    return commit('calcTokensExpire', Math.round(Date.now() / 1000))
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'calcTokensExpire', inprogress: false})
                });
        },
        calcRequestsErrors({dispatch, commit}) {
            dispatch('setLastCall', {name: 'calcRequestsErrors', time: Date.now() / 1000})

            Promise.resolve()
                .then(() => {
                    return commit('calcRequestsErrors', Math.round(Date.now() / 1000))
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'calcRequestsErrors', inprogress: false})
                });
        },
        checkSiteVersion({dispatch, commit}) {
            dispatch('setLastCall', {name: 'checkSiteVersion', time: Date.now() / 1000})

            fetch('/version.json', {cache: 'no-store'})
                .then((response) => {
                    //console.log(response)
                    if (response.ok) {
                        return response.json();
                    } else {
                        console.warn(response.status, response)
                    }
                })
                .then((data) => {
                    if (!data?.version) {
                        return false
                    }
                    const currentVersion = localStorage.getItem(process.env.VUE_APP_PRODUCT + '.app_version');
                    if (!currentVersion) {
                        localStorage.setItem(process.env.VUE_APP_PRODUCT + '.app_version', data.version);
                    } else if (currentVersion !== data.version) {
                        console.error('A new version of the website is available. The page will be updated.');
                        localStorage.setItem(process.env.VUE_APP_PRODUCT + '.app_version', data.version);
                        commit('setReloadRequired')
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'checkSiteVersion', inprogress: false})
                });
        }
    },
    mutations: {
        addRequestError(state, error) {
            let type = 'unknown'
            if (error.code === 'ECONNABORTED') {
                type = 'timeout'
            }
            if (error.code === 'ERR_NETWORK') {
                type = 'network'
            }
            if (error.code === 'ERR_CANCELED') {
                type = 'canceled'
            }

            const status = error.response?.status
            if (status >= 500) type = '5xx'
            if (status >= 400) type = '4xx'

            let t = Math.round(Date.now() / 1000)
            if (!state.httpErrors[type]['list'][t]) {
                state.httpErrors[type]['list'][t] = 0
            }
            state.httpErrors[type]['list'][t]++
            state.httpErrors[type]['count']++
            state.httpErrors[type]['last'] = Math.round(Date.now() / 1000);
        },
        calcRequestsErrors(state, time) {
            Object.keys(state.httpErrors).forEach((type) => {
                const tt = (type === 'network') ? 5 : 10
                let t = time - state.httpErrors[type]['last']
                if (t > tt) {
                    state.httpErrors[type] = {'list': {}, 'last': 0, 'count': 0}
                } else {
                    let count = 0;
                    Object.keys(state.httpErrors[type]['list']).forEach((t) => {
                        if (t + tt < time) delete state.httpErrors[type]['list'][t]
                        else count += state.httpErrors[type]['list'][t]
                    })
                    state.httpErrors[type]['count'] = count
                }
            })
        },
        setToken(state, token) {
            if (!(token > '')) return false
            let t = Math.round(Date.now() / 1000)
            state.tokens = {
                token_type: 'Bearer',
                access_token: token,
                expires_in: 30,
                expires_in_time: t + 30,
                refresh_token: token,
                refresh_expires_in: 30,
                refresh_expires_in_time: t + 30,
            }
        },
        updateTokens(state, tokens) {
            tokens = tokens || {}
            state.tokens = tokens
            //if(tokens.access_token>'')
            localStorage.setItem(process.env.VUE_APP_PRODUCT + '.authtoken', tokens.access_token || '')
            if (tokens.refresh_token > '')
                localStorage.setItem(process.env.VUE_APP_PRODUCT + '.authtoken', tokens.refresh_token || '')
        },
        calcTokensExpire(state, time) {
            if (!state.tokens) return;
            state.tokens.expires_in = state.tokens.expires_in_time - time
            if (state.tokens.expires_in <= 0) state.tokens.access_token = ''
            state.tokens.refresh_expires_in = state.tokens.refresh_expires_in_time - time
            if (state.tokens.refresh_expires_in <= 0) state.tokens.refresh_token = ''
        },
        resetAccessToken(state) {
            if (state.tokens) state.tokens.access_token = ''
        },
        setReloadRequired(state) {
            state.reload_required = true
        },
    },
    getters: {
        getHttpErrors(state) {
            return state.httpErrors
        },
        getNetworkStatus(state) {
            return (!state.httpErrors.network.count)
                && (!state.httpErrors.timeout.count)
                && (state.httpErrors['5xx']['count'] < 3) ? 'ok' :
                (state.httpErrors.network.count > 1) ? 'critical' : 'warning'
        },
        getTokens(state) {
            return state.tokens
        },
        getHeaderAuthorization(state) {
            let type = (state.tokens || {}).token_type || 'Bearer'
            type = type.charAt(0).toUpperCase() + type.slice(1)
            let token = (state.tokens || {}).access_token || 'dummy'
            return `${type} ${token}`
        },
        getRefreshHeaderAuthorization(state) {
            let type = (state.tokens || {}).token_type || 'Bearer'
            type = type.charAt(0).toUpperCase() + type.slice(1)
            let token = (state.tokens || {}).refresh_token || 'dummy'
            return `${type} ${token}`
        },
        getRefreshToken(state) {
            return state.tokens.refresh_token
        },
        getAccessToken(state) {
            return state.tokens.access_token
        },
        getApiTokenExpiresIn(state) {
            return state.tokens.expires_in || -1
        },
        getApiToken(state) {
            return state.tokens.access_token
        },
        isGuest(state) {
            return !(state.tokens.access_token && state.tokens.access_token > '')
        },
        getReloadRequired(state) {
            return state.reload_required
        }
    }
}
